import React, { useState, useEffect } from 'react';
import NavigationBar from '../components/NavigationBar';
import NowOverlay, { isNowVideo, getNowVideoUrl } from '../components/NowOverlay';
import { getGalleryWeekendEntries, getNowPageHeader } from '../api/api';
import './GalleryWeekend.css';

const DEFAULT_TITLE = 'NOW';
const DEFAULT_SUBTITLE = 'Impressionen vom Gallery Weekend am Rosa-Luxemburg-Platz.';

const STRAPI_URL = process.env.REACT_APP_STRAPI_API_URL;

function getImageUrl(entry, size = 'large') {
  const formats = entry.image?.formats;
  if (!formats && !entry.image?.url) return null;
  const isMobile = window.innerWidth < 768;
  if (isMobile) {
    return STRAPI_URL + (formats?.small?.url || formats?.medium?.url || entry.image?.url);
  }
  if (size === 'thumbnail') {
    return STRAPI_URL + (formats?.thumbnail?.url || formats?.small?.url || entry.image?.url);
  }
  return STRAPI_URL + (formats?.large?.url || formats?.medium?.url || entry.image?.url);
}

const GalleryWeekend = () => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);
  const [pageTitle, setPageTitle] = useState(DEFAULT_TITLE);
  const [pageSubtitle, setPageSubtitle] = useState(DEFAULT_SUBTITLE);

  useEffect(() => {
    getGalleryWeekendEntries().then(data => {
      if (data?.data) {
        setEntries(data.data);
      }
      setLoading(false);
    }).catch(() => setLoading(false));

    getNowPageHeader().then(data => {
      const header = data?.data;
      if (header?.title) setPageTitle(header.title);
      if (header?.subtitle) setPageSubtitle(header.subtitle);
    }).catch(() => {});
  }, []);

  return (
    <>
      <NavigationBar />

      <div className="gallery-weekend-page">
        <header className="gallery-weekend-header">
          <h1>{pageTitle}</h1>
          <p className="gallery-weekend-lede">
            {pageSubtitle}
          </p>
        </header>

        {loading ? (
          <p style={{ color: '#718096' }}>Lade Bilder...</p>
        ) : entries.length === 0 ? (
          <p style={{ color: '#718096' }}>Noch keine Bilder vorhanden.</p>
        ) : (
          <div className="gallery-grid">
            {entries.map((entry, i) => (
              <button
                key={entry.id || i}
                className="gallery-tile"
                onClick={() => {
                  setActiveIndex(i);
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: 'gallery_weekend_image_click',
                    entry_caption: entry.caption,
                  });
                }}
              >
                {isNowVideo(entry) ? (
                  // "#t=0.1" laesst den Browser das erste Bild des Videos zeigen
                  <video
                    src={`${getNowVideoUrl(entry)}#t=0.1`}
                    preload="metadata"
                    muted
                    playsInline
                  />
                ) : (
                  <img
                    src={getImageUrl(entry, 'thumbnail')}
                    alt={entry.caption || 'Gallery Weekend'}
                    loading="lazy"
                  />
                )}
              </button>
            ))}
          </div>
        )}
      </div>

      <NowOverlay
        entries={activeIndex !== null ? entries : []}
        startIndex={activeIndex || 0}
        onClose={() => setActiveIndex(null)}
      />
    </>
  );
};

export default GalleryWeekend;
